/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GeoPolygon } from '../models/GeoPolygon';
import type { GeoPolygon_GeoPolygonInput } from '../models/GeoPolygon_GeoPolygonInput';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class GeoPolygonService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Creates a GeoPolygon resource.
     * Creates a GeoPolygon resource.
     * @param requestBody The new GeoPolygon resource
     * @returns GeoPolygon GeoPolygon resource created
     * @throws ApiError
     */
    public apiGeotilingpolygonsPost(
        requestBody: GeoPolygon_GeoPolygonInput,
    ): CancelablePromise<GeoPolygon> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/geo/tiling/polygons',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid input`,
                403: `Forbidden`,
                422: `Unprocessable entity`,
            },
        });
    }
}
